import { IMongoWorkspace } from '../../interfaces/mongo-workspace.interface';

export interface IGroup extends IMongoWorkspace {
    name: string;
    permissions: string[];
}
